// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1y-2";
export var blackBorderOnHover = "_1y-7";
export var cell = "_1y-6";
export var cellContainer = "_1y-3";
export var checked = "_1y-8";
export var disabled = "_1y-5";
export var featuredIconCellContainer = "_1y-9";
export var featuredIconTextContainer = "_1y-b";
export var featuredIconWrapper = "_1y-a";
export var noBorder = "_1y-c";
export var orangeSelectedRow = "_4q-3";
export var overflowableText = "_1y-0";
export var overflowableTextContainer = "_1y-1";
export var row = "_1o-0";
export var rowCheckboxCell = "_1y-4";
export var selectableTable = "_4q-2";